/* global $:false */

import MarketLotShowBidFormResponse from 'src/public/market_lot_show_bid_form_response.js'

export default class MarketLotShowBidForm {
  constructor () {
    this.findElements = this.findElements.bind(this)
    this.setupBindings = this.setupBindings.bind(this)
    this.update = this.update.bind(this)
    this.clearAmountInput = this.clearAmountInput.bind(this)
    this.findElements()
    this.bidDialog = new MarketLotShowBidFormResponse()
    this.setupBindings()
    this.proxyRefreshCallback()
  }

  findElements () {
    this.form = $('.js-market-lot-show-form')
    this.spinner = $('.js-market-lot-show-spinner')
    this.amountField = this.form.find('[data-identifier=bid_form_amount]')
    this.placeBidButton = this.form.find('[data-identifier=place_bid_button]')
  }

  setupBindings () {
    this.form.bind('ajax:before', () => {
      this.placeBidButton.prop('disabled', true)
    })
  }

  // When the bid dialog signals a refresh, we signal that we want a refresh, too.
  proxyRefreshCallback () {
    this.refreshCallback = function () {}
    this.bidDialog.refreshCallback = () => this.refresh()
  }

  refresh () {
    this.refreshCallback()
  }

  update (data) {
    if (data.auction_processed) {
      // Invoice was generated, hide everything.
      this.form.hide()
      this.spinner.hide()
    } else if (data.bidding_definitely_ended) {
      // No more bidding but waiting for invoice, show spinner.
      this.form.hide()
      this.spinner.show()
    } else {
      // Bidding ongoing, show form.
      this.form.show()
      this.spinner.hide()
    }
  }

  clearAmountInput () {
    this.amountField.val(null)
  }
}
